import { Link } from 'react-router-dom';
import { googleReviewsUrl } from '../../lib/reviews';
import { CurveDivider, StarRating } from '../ui';
import { FEATURED_TESTIMONIAL, TESTIMONIALS, type HomeTestimonial } from './testimonials';

/**
 * Home testimonials (layout report move #8): real Google reviews only, from
 * ./testimonials.ts. One large pull quote beside the heading, then a quiet
 * set of shorter quotes in flowing columns (no cards, no carousel). Every
 * quote opens with five small gold stars (owner ruling 09-29: a lone gold
 * quote glyph read like a two-star rating), so no quote marks are drawn.
 * Static text, so the prerendered HTML and hydration match.
 * Home rhythm: this is the page's one full-width navy band, entered through
 * the page's one body curve (the hero keeps its own edge curve).
 */
// Keep "Dr." with the name that follows (a non-breaking space; the words are unchanged).
const keepTitles = (text: string) => text.replace(/\bDr\. /g, 'Dr.\u00a0');

function Quote({ t, featured = false }: { t: HomeTestimonial; featured?: boolean }) {
  return (
    <figure className={featured ? 've-home-voice ve-home-voice--featured' : 've-home-voice'}>
      <StarRating size={featured ? 'lg' : 'md'} label="5 out of 5 stars" className="ve-home-voice-stars" />
      <blockquote className="ve-home-voice-quote">
        <p>{keepTitles(t.quote)}</p>
      </blockquote>
      <figcaption className="ve-home-voice-name">
        {t.name}
        <span className="ve-home-voice-source">Google review</span>
      </figcaption>
    </figure>
  );
}

export default function Testimonials() {
  return (
    <section className="ve-home-voices ve-home-voices--band" aria-labelledby="home-voices-title">
      <CurveDivider flip className="ve-home-voices-curve" />
      <div className="ve-container ve-container--wide">
        <div className="ve-home-voices-top">
          <div className="ve-home-voices-head">
            <span className="ve-eyebrow">From our Google reviews</span>
            <h2 id="home-voices-title">What Families Say</h2>
            <p className="ve-home-voices-links">
              <Link to="/patient-reviews/">Read more patient reviews</Link>
              <Link to="/reviews/">Reviews by condition</Link>
              <a href={googleReviewsUrl()} target="_blank" rel="noopener noreferrer">
                All reviews on Google<span className="sr-only"> (opens in a new tab)</span>
              </a>
            </p>
          </div>
          <Quote t={FEATURED_TESTIMONIAL} featured />
        </div>
        <ul className="ve-home-voices-list">
          {TESTIMONIALS.map((t) => (
            <li key={t.sourceIndex}>
              <Quote t={t} />
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
